import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { Investment } from '@app/core/model/entities/investment/investment';
import { Field } from '@app/core/model/other/field-config';
import { isNullOrEmpty } from '@app/shared/extra/utils';
import { OkCancelModalDialogComponent } from '@app/shared/popup/ok-cancel/ok-cancel.modal-dialog';
import { FieldService } from '@services/field.service';
import { AccessManager } from '@services/managers/access.manager';
import { from, Observable } from 'rxjs';
import { filter, mergeMap, toArray } from 'rxjs/operators';

@Component({
  selector: 'investment-duplicate-modal',
  templateUrl: './investment-duplicate-modal.component.html',
  standalone: false
})
export class InvestmentDuplicateModalComponent extends OkCancelModalDialogComponent {
  protected missingRequiredFields$: Observable<Field[]>;
  private readonly investments: Investment[] = inject(MAT_DIALOG_DATA).investments;
  private readonly fieldService = inject(FieldService);
  private readonly accessManager = inject(AccessManager);

  constructor() {
    super();
    // All fields with a value in all selected investments
    const investmentsExistingFields = this.investments.flatMap(investment =>
      Object.entries(investment)
        .filter(([_, value]) => !isNullOrEmpty(value))
        .map(([key]) => key)
        .concat(Object.keys(investment.properties))
    );

    this.missingRequiredFields$ = this.fieldService.getFields({computed: 'ALL', entityType: EntityTypeEnum.INVESTMENT}).pipe(
      mergeMap(fields => from(fields)),
      // Keep fields that exist in all investments
      filter(field => !field.computed  && investmentsExistingFields.includes(field.code)),
      // Keep remaining fields without sufficient user permissions
      filter(({code}) => !this.accessManager.hasFieldWriteOnCreateAccess(code, EntityTypeEnum.INVESTMENT)),
      toArray(),
      takeUntilDestroyed()
    );
  }
}
